
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/richiesta-attivazione",
      function () {
        return require("private-next-pages/richiesta-attivazione/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/richiesta-attivazione"])
      });
    }
  